// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".suucB {\n  position: fixed !important;\n  bottom: var(--space-300);\n  right: 80px;\n}\n\n.R6xQU {\n  right: 140px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpButton": "suucB",
	"withAccessibilityWidget": "R6xQU"
};
export default ___CSS_LOADER_EXPORT___;
